import React, { useState } from "react";
import { useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import {
  formatDateTime,
  getSubscriptionSubjectName,
  getSubscriptionUserName,
  getSubscriptionUserPhone,
} from "./helpers";

const ActiveSubscriptionsTable = () => {
  const subscriptions = useSelector(
    (state) => state.asqueraPractice.activeSubscriptions
  );
  const subjects = useSelector((state) => state.asqueraPractice.subjects);
  const isLoading = useSelector(
    (state) => state.asqueraPractice.activeSubscriptionsLoading
  );
  const [pageNumber, setPageNumber] = useState(0);
  const [size, setPerPage] = useState(10);
  const [offset, setPage] = useState(0);

  const list = Array.isArray(subscriptions) ? subscriptions : [];
  const paged = list.slice(pageNumber * size, pageNumber * size + size);

  const viewData = () => {};

  const Data = paged.map((data, index) => ({
    ...data,
    index: `#${pageNumber * size + index + 1}`,
    id: data?.id,
    student_name: getSubscriptionUserName(data),
    phone: getSubscriptionUserPhone(data),
    subject_name: getSubscriptionSubjectName(data, subjects),
    amount: data?.amount ?? "-",
    expires_at: formatDateTime(data?.expires_at),
    created_at: formatDateTime(data?.created_at),
  }));

  const columns = [
    {
      Header: "رقم",
      accessor: "index",
    },
    {
      Header: "اسم المستخدم",
      accessor: "student_name",
    },
    {
      Header: "رقم الهاتف",
      accessor: "phone",
    },
    {
      Header: "المادة",
      accessor: "subject_name",
    },
    {
      Header: "المبلغ",
      accessor: "amount",
    },
    {
      Header: "تاريخ الانتهاء",
      accessor: "expires_at",
    },
    {
      Header: "تاريخ الإنشاء",
      accessor: "created_at",
    },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Title=""
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(list.length / size) || 1}
    />
  );
};

export default ActiveSubscriptionsTable;
